import {
  ElementCategoryID,
  ProductCategoryId,
  ServiceCategoryId,
  SystemCategoryId,
} from '@shared/models/element-categories.model';
import { getElementCategoryAndSelectionsByProductId } from '@shared/helpers/element-category.helpers';
import type { ProductID } from '@shared/models/product.model';
import { NodonIcons } from '@ui/Icon/Icon';

type ElementCategoryIconName = keyof NodonIcons['elementCategory'];

const iconMap: Record<string, ElementCategoryIconName> = {
  [ElementCategoryID.Column]: 'column',
  [ElementCategoryID.Beam]: 'beam',
  [ElementCategoryID.Wall]: 'wall',
  [ElementCategoryID.Slab]: 'slab',
  [ElementCategoryID.Heating]: 'heating',
  [ElementCategoryID.Cooling]: 'cooling',
  [ElementCategoryID.Labour]: 'labour',
  [ElementCategoryID.WindowsDoors]: 'windows',
  [ElementCategoryID.Concrete]: 'concrete',
  [ElementCategoryID.Wood]: 'wood',
  [ElementCategoryID.Insulation]: 'insulation',
  [ElementCategoryID.Metal]: 'metal',
  [ElementCategoryID.Gypsum]: 'gypsum',
  [ElementCategoryID.Ceramics]: 'ceramics',
  [ElementCategoryID.Energy]: 'energy',
  [ElementCategoryID.OtherProduct]: 'otherproduct',
  [ElementCategoryID.Other]: 'other',
  [ElementCategoryID.AirHandlingUnit]: 'ventilation',
  [ElementCategoryID.Maintenance]: 'maintenance',
} satisfies Record<
  | ProductCategoryId
  | SystemCategoryId
  | ServiceCategoryId
  | ElementCategoryID.Maintenance,
  ElementCategoryIconName
>;

export const getElementIconCategoryName = (
  categoryId: ElementCategoryID | undefined,
): ElementCategoryIconName =>
  (categoryId ? iconMap[categoryId] : undefined) ?? 'other';

export const getProductCategoryIconName = (
  productId: ProductID,
): ElementCategoryIconName =>
  getElementIconCategoryName(
    getElementCategoryAndSelectionsByProductId(productId)?.category_id,
  );
